// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__S5wUx","log":"ModalInventoryLogs_log__10SK9","date":"ModalInventoryLogs_date__rqmEu","userName":"ModalInventoryLogs_userName__2H3Cr"};